<div class="change-task-author" [formGroup]="authorFormGroup">
    <div class="example-form">
        <mat-form-field
            class="example-full-width d-block"
            floatLabel="always"
            [ngClass]="{
                'form-validator-message-text':
                    authorFormGroup.get('robutsAuthorType').touched &&
                    authorFormGroup.get('Tipo').invalid
            }"
        >
            <mat-label>Autor</mat-label>
            <mat-select formControlName="robutsAuthorType">
                <mat-option
                    *ngFor="let option of authorList"
                    [value]="option.viewValue"
                >
                    {{ option.viewValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <!-- Errors will be displayed from old tipo controller -->
        <mat-error
            *ngIf="
                authorFormGroup.get('Tipo') &&
                authorFormGroup.get('Tipo').invalid
            "
        >
            <span
                *ngIf="
                    authorFormGroup.get('Tipo') &&
                    authorFormGroup.get('Tipo').errors.required
                "
                class="validation-span"
                >Obligatorio</span
            >
        </mat-error>
    </div>

    <div class="example-form" *ngIf="dropDownActivate.user">
        <mat-form-field
            class="example-full-width d-block"
            floatLabel="always"
            [ngClass]="{
                'form-validator-message-text':
                    authorFormGroup.get('Usuario').touched &&
                    authorFormGroup.get('Usuario').invalid
            }"
        >
            <mat-label>Usuario</mat-label>
            <mat-select
                formControlName="Usuario"
                (selectionChange)="OnUserChange($event)"
            >
                <mat-option
                    *ngFor="let option of userList"
                    [value]="option.value"
                >
                    {{ option.viewValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-error
            *ngIf="
                authorFormGroup.get('Usuario') &&
                authorFormGroup.get('Usuario').invalid
            "
        >
            <span
                *ngIf="
                    authorFormGroup.get('Usuario') &&
                    authorFormGroup.get('Usuario').errors.required
                "
                class="validation-span"
                >Obligatorio</span
            >
        </mat-error>
    </div>

    <div class="example-form" *ngIf="dropDownActivate.doctor">
        <mat-form-field
            class="example-full-width d-block"
            floatLabel="always"
            [ngClass]="{
                'form-validator-message-text':
                    authorFormGroup.get('Medico').touched &&
                    authorFormGroup.get('Medico').invalid
            }"
        >
            <mat-label>Medico</mat-label>
            <mat-select
                formControlName="Medico"
                (selectionChange)="OnUserChange($event)"
            >
                <mat-option
                    *ngFor="let option of medicoList"
                    [value]="option.value"
                >
                    {{ option.viewValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-error
            *ngIf="
                authorFormGroup.get('Medico') &&
                authorFormGroup.get('Medico').invalid
            "
        >
            <span
                *ngIf="
                    authorFormGroup.get('Medico') &&
                    authorFormGroup.get('Medico').errors.required
                "
                class="validation-span"
                >Obligatorio</span
            >
        </mat-error>
    </div>

    <div class="example-form" *ngIf="dropDownActivate.coordinador">
        <mat-form-field
            class="example-full-width d-block"
            floatLabel="always"
            [ngClass]="{
                'form-validator-message-text':
                    authorFormGroup.get('Coordinator').touched &&
                    authorFormGroup.get('Coordinator').invalid
            }"
        >
            <mat-label>Coordinador</mat-label>
            <mat-select
                formControlName="Coordinator"
                (selectionChange)="OnUserChange($event)"
            >
                <mat-option
                    *ngFor="let option of coordinatorList"
                    [value]="option.value"
                >
                    {{ option.viewValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-error
            *ngIf="
                authorFormGroup.get('Coordinator') &&
                authorFormGroup.get('Coordinator').invalid
            "
        >
            <span
                *ngIf="
                    authorFormGroup.get('Coordinator') &&
                    authorFormGroup.get('Coordinator').errors.required
                "
                class="validation-span"
                >Obligatorio</span
            >
        </mat-error>
    </div>
    <input type="hidden" formControlName="Nombre" />
    <input type="hidden" formControlName="MedicoId" />
</div>
